import { render, staticRenderFns } from "./PeriodsSelectionSectionPeriodCard.vue?vue&type=template&id=16fe28a8"
import script from "./PeriodsSelectionSectionPeriodCard.vue?vue&type=script&lang=js"
export * from "./PeriodsSelectionSectionPeriodCard.vue?vue&type=script&lang=js"
import style0 from "./PeriodsSelectionSectionPeriodCard.vue?vue&type=style&index=0&id=16fe28a8&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports